export enum SubscriptionPlan {
  FREE = "Free",
  PERSONAL = "Personal",
  PRO = "Pro",
  BUSINESS = "Business",
  ENTERPRISE = "Enterprise",
}
